const scope = 'loop/Dashboard/Employer';

export const GET_EMPLOYERS = `${scope}/GET_EMPLOYERS`;
export const GET_EMPLOYERS_SUCCESS = `${scope}/GET_EMPLOYERS_SUCCESS`;
export const GET_EMPLOYERS_ERROR = `${scope}/GET_EMPLOYERS_ERROR`;

export const GET_EMPLOYER = `${scope}/GET_EMPLOYER`;
export const GET_EMPLOYER_SUCCESS = `${scope}/GET_EMPLOYER_SUCCESS`;
export const GET_EMPLOYER_ERROR = `${scope}/GET_EMPLOYER_ERROR`;

export const GET_EMPLOYER_JOBS = `${scope}/GET_EMPLOYER_JOBS`;
export const GET_EMPLOYER_JOBS_SUCCESS = `${scope}/GET_EMPLOYER_JOBS_SUCCESS`;
export const GET_EMPLOYER_JOBS_ERROR = `${scope}/GET_EMPLOYER_JOBS_ERROR`;

export const GET_EMPLOYES_PER_PAGE = 20;
export const GET_EMPLOYER_JOBS_PER_PAGE = 4;






